import React from 'react';
import parse from 'html-react-parser';
import './app-courtesy-page.scss';
import { AppSvgIcon } from '../svg-icon/app-svg-icon';

export interface AppCourtesyPageProps {
  icon?: any;
  title?: string;
  subtitle?: string;
  notes?: string[];
}

function AppCourtesyPage(props: AppCourtesyPageProps) {
  const { icon, title, subtitle, notes } = props;

  return (
    <div className='courtesy-page-container'>
      <div className='courtesy-page-content'>
        {icon && (
          <div className='courtesy-page-icon'>
            <AppSvgIcon icon={icon} />
          </div>
        )}
        {title && <h1>{title}</h1>}
        {subtitle && <h2>{subtitle}</h2>}
        {notes?.length && (
          <div className='courtesy-page-notes'>
            <div className='courtesy-page-notes-separator' />
            {notes.map((note, i) => (
              <p key={i}>{parse(note)}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AppCourtesyPage;
